module.exports = __webpack_public_path__ + "img/ctrl-s-dagger-1.77e63514.svg";